import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _values from "lodash/values";

import { CANDIDATE_SEARCH_STATUS, QUESTION_FLOW } from "lib/constants";
import { questionSetFilter } from "redux/questions/actions";

import SelectOne from "./SelectOne";

class PrefSearchStatus extends React.PureComponent {
    static propTypes = {
        ...SelectOne.propTypes,
        flow: PropTypes.oneOf(_values(QUESTION_FLOW)).isRequired,
    };

    onSelect = (event) => {
        const target = event.currentTarget;

        this.props.handleAnswer({
            preSubmit: this.preSubmit,
            questionID: this.props.id,
            response: target.dataset.id,
            responseText: target.dataset.value,
        });
    };

    preSubmit = (answer) => {
        const status = Number(answer.response);
        if (
            this.props.flow === QUESTION_FLOW.ONBOARD &&
            status === CANDIDATE_SEARCH_STATUS.EMPLOYED_INACTIVE
        ) {
            this.props.questionSetFilter({
                filter: "preferences",
                value: false,
            });
        }

        return new Promise((resolve) => {
            resolve(answer);
        });
    };

    render() {
        return <SelectOne {...this.props} />;
    }
}

export default connect(null, { questionSetFilter })(PrefSearchStatus);
